import * as React from "react";

import { Message as caseMessage, MessageType } from "@teamprevent/common/messaging/models";
import { Button, Container, Message, Segment } from "semantic-ui-react";

export interface CaseSubjectMessageProps {
    messages: caseMessage[];
    caseId: string;
}

const CaseSubjectMessage: React.FC<CaseSubjectMessageProps> = ({ messages, caseId }) => {
    const orderedMessages = messages.sort((a, b) => b.dateCreated.valueOf() - a.dateCreated.valueOf());

    const renderMessage = (message: caseMessage) => {
        if (message.caseMessageType === MessageType.NoReplyRequired)
        {
            return (
                <Message positive>
                    <Message.Header>No response required</Message.Header>
                    <p>
                        { message.message }
                    </p>
                </Message>
            );
        }

        return (
            <Message info>
                <p>{message.message}</p>
            </Message>
        );
    };

    return (
        <Segment.Group className="message-segments">
            {
                orderedMessages.map((message, index) => {
                    return (
                        <Segment key={index}>
                            { renderMessage(message) }
                            { message.documents.map((document, i) => (
                                <a
                                    key={i}
                                    // eslint-disable-next-line max-len
                                    href={`/api/Messaging/${caseId}/evidence/${document.blobId}?fileName=${document.fileName}`}
                                >
                                    <Button content={document.fileName} type="button" />
                                </a>
                            ))}
                            <Container textAlign="right">
                                <p>{"Created by: " + message.createdBy.name + " Date created: " + message.dateCreated.format("DD/MM/YY @ h:mma")} </p>
                            </Container>
                        </Segment>
                    );
                })
            }
        </Segment.Group>
    );
};

export {
    CaseSubjectMessage
};
